/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRequestInvoiceGetApplicationGet } from '../fn/invoice-request/api-request-invoice-get-application-get';
import { ApiRequestInvoiceGetApplicationGet$Params } from '../fn/invoice-request/api-request-invoice-get-application-get';
import { apiRequestInvoiceGetPreviewGet } from '../fn/invoice-request/api-request-invoice-get-preview-get';
import { ApiRequestInvoiceGetPreviewGet$Params } from '../fn/invoice-request/api-request-invoice-get-preview-get';
import { apiRequestInvoiceGetRequestByIdGet } from '../fn/invoice-request/api-request-invoice-get-request-by-id-get';
import { ApiRequestInvoiceGetRequestByIdGet$Params } from '../fn/invoice-request/api-request-invoice-get-request-by-id-get';
import { apiRequestInvoiceInitialApplicationGet } from '../fn/invoice-request/api-request-invoice-initial-application-get';
import { ApiRequestInvoiceInitialApplicationGet$Params } from '../fn/invoice-request/api-request-invoice-initial-application-get';
import { apiRequestInvoiceInitialGet } from '../fn/invoice-request/api-request-invoice-initial-get';
import { ApiRequestInvoiceInitialGet$Params } from '../fn/invoice-request/api-request-invoice-initial-get';
import { apiRequestInvoiceSaveSubmitPost } from '../fn/invoice-request/api-request-invoice-save-submit-post';
import { ApiRequestInvoiceSaveSubmitPost$Params } from '../fn/invoice-request/api-request-invoice-save-submit-post';
import { CourseBillingRequest } from '../models/course-billing-request';
import { InitReceiptByApplication } from '../models/init-receipt-by-application';
import { InvoiceRequest } from '../models/invoice-request';
import { InvoiceRequestApiRespModel } from '../models/invoice-request-api-resp-model';

@Injectable({ providedIn: 'root' })
export class InvoiceRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRequestInvoiceInitialGet()` */
  static readonly ApiRequestInvoiceInitialGetPath = '/api/Request/Invoice/Initial';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestInvoiceInitialGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceInitialGet$Response(params?: ApiRequestInvoiceInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequest>> {
    return apiRequestInvoiceInitialGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestInvoiceInitialGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceInitialGet(params?: ApiRequestInvoiceInitialGet$Params, context?: HttpContext): Observable<InvoiceRequest> {
    return this.apiRequestInvoiceInitialGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<InvoiceRequest>): InvoiceRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestInvoiceInitialApplicationGet()` */
  static readonly ApiRequestInvoiceInitialApplicationGetPath = '/api/Request/Invoice/InitialApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestInvoiceInitialApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceInitialApplicationGet$Response(params?: ApiRequestInvoiceInitialApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseBillingRequest>> {
    return apiRequestInvoiceInitialApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestInvoiceInitialApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceInitialApplicationGet(params?: ApiRequestInvoiceInitialApplicationGet$Params, context?: HttpContext): Observable<CourseBillingRequest> {
    return this.apiRequestInvoiceInitialApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseBillingRequest>): CourseBillingRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestInvoiceGetApplicationGet()` */
  static readonly ApiRequestInvoiceGetApplicationGetPath = '/api/Request/Invoice/GetApplication';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestInvoiceGetApplicationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceGetApplicationGet$Response(params?: ApiRequestInvoiceGetApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InitReceiptByApplication>>> {
    return apiRequestInvoiceGetApplicationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestInvoiceGetApplicationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceGetApplicationGet(params?: ApiRequestInvoiceGetApplicationGet$Params, context?: HttpContext): Observable<Array<InitReceiptByApplication>> {
    return this.apiRequestInvoiceGetApplicationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InitReceiptByApplication>>): Array<InitReceiptByApplication> => r.body)
    );
  }

  /** Path part for operation `apiRequestInvoiceGetRequestByIdGet()` */
  static readonly ApiRequestInvoiceGetRequestByIdGetPath = '/api/Request/Invoice/GetRequestById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestInvoiceGetRequestByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceGetRequestByIdGet$Response(params?: ApiRequestInvoiceGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequest>> {
    return apiRequestInvoiceGetRequestByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestInvoiceGetRequestByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceGetRequestByIdGet(params?: ApiRequestInvoiceGetRequestByIdGet$Params, context?: HttpContext): Observable<InvoiceRequest> {
    return this.apiRequestInvoiceGetRequestByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<InvoiceRequest>): InvoiceRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestInvoiceSaveSubmitPost()` */
  static readonly ApiRequestInvoiceSaveSubmitPostPath = '/api/Request/Invoice/SaveSubmit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestInvoiceSaveSubmitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestInvoiceSaveSubmitPost$Response(params?: ApiRequestInvoiceSaveSubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequestApiRespModel>> {
    return apiRequestInvoiceSaveSubmitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestInvoiceSaveSubmitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestInvoiceSaveSubmitPost(params?: ApiRequestInvoiceSaveSubmitPost$Params, context?: HttpContext): Observable<InvoiceRequestApiRespModel> {
    return this.apiRequestInvoiceSaveSubmitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<InvoiceRequestApiRespModel>): InvoiceRequestApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestInvoiceGetPreviewGet()` */
  static readonly ApiRequestInvoiceGetPreviewGetPath = '/api/Request/Invoice/GetPreview';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestInvoiceGetPreviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceGetPreviewGet$Response(params?: ApiRequestInvoiceGetPreviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequest>> {
    return apiRequestInvoiceGetPreviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestInvoiceGetPreviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestInvoiceGetPreviewGet(params?: ApiRequestInvoiceGetPreviewGet$Params, context?: HttpContext): Observable<InvoiceRequest> {
    return this.apiRequestInvoiceGetPreviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<InvoiceRequest>): InvoiceRequest => r.body)
    );
  }

}
